import { render, staticRenderFns } from "./CommunitiesTable.vue?vue&type=template&id=ffa3b162"
import script from "./CommunitiesTable.vue?vue&type=script&lang=js"
export * from "./CommunitiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports